// extracted by mini-css-extract-plugin
module.exports = {"yt-lite":"styles_yt-lite__CMfkP","lty-playbtn":"styles_lty-playbtn__4OQ9M","lyt-activated":"styles_lyt-activated__tinui","yt-lite-thumbnail":"styles_yt-lite-thumbnail__MLoT5"};